import { create } from 'zustand';

export type PopupRequest = {
  title?: string;
  content: string;
  closeText?: string;
  onClose?: () => void;
  closable?: boolean;
};

export type PopupState = {
  isOpen: boolean;
  popupRequest: PopupRequest;
};

export type PopupActions = {
  openPopup: (request: PopupRequest) => void;
  closePopup: () => void;
};

export type PopupStore = PopupState & PopupActions;

export const usePopupStore = create<PopupStore>((set, get) => ({
  isOpen: false,
  popupRequest: {
    content: '',
    closable: true,
  },

  openPopup: (request: PopupRequest) => {
    set({ popupRequest: request, isOpen: true });
  },

  closePopup: () => {
    const { popupRequest } = get();
    if (popupRequest.onClose) {
      popupRequest.onClose();
    }
    set({ isOpen: false });
  },
}));
